import { Stack, Label, FontIcon, IStackTokens } from '@fluentui/react';
import React, { useContext, useState } from 'react';
import styles from '../styles/pokemon.module.scss';
import {TProduct, TSize } from '../constants/types';
import Product from './Product/productComponent';
import GlobalContext from '../_contexts/GlobalContext';

export interface ImiscComponentProps {
    satprice: number;
    eurprice: number;
    windowSize: TSize;
    onImageClick: Function;
    isdev: boolean;
    onBuyClick: Function;
    products : TProduct[];
    showMinimize?: boolean;
    SetSelectedProductForAlert?: Function;
    AlertCoachmarkVisible: boolean;
}

const Misc : React.FunctionComponent<ImiscComponentProps> = (props : ImiscComponentProps) => {
    const [show, setshow] = useState<boolean>(true);

    const productTokens: IStackTokens = {
        childrenGap: 10,
        padding: 5
    };

    const { Strings } = useContext(GlobalContext);

    return (   
        <Stack className={styles.mainSection}>
            <Stack horizontal style={{width:"100%", cursor:"pointer"}} onClick={() => {setshow(!show);}}>
                <Stack horizontal className={styles.boosterLabelMain}>
                    <Label className={styles.boosterLabel} >{Strings.Misc}</Label>
                </Stack>
                {props.showMinimize && <Stack horizontal horizontalAlign='end' style={{width:"100%",padding:5}} >
                    <FontIcon aria-label="Hide" 
                            iconName={show ? "ChevronUp" : "ChevronDown"}
                            className={styles.hideBoosterImage} />
                </Stack>}
            </Stack>
            <hr className={styles.mainhr} />
            {props.products.length > 0 && show && <Stack horizontal wrap tokens={productTokens} horizontalAlign='start' style={{maxWidth:""}}>
                                    {props.products.map(product => {
                                        return  <div style={{maxWidth:props.windowSize.x < 960 ? 430 : ""}}>
                                                    <Product hideSwipe={props.windowSize.x < 800 ? false : true} 
                                                        AlertCoachmarkVisible={props.AlertCoachmarkVisible}
                                                        SetSelectedProductForAlert={props.SetSelectedProductForAlert}
                                                        onBuyClick={props.onBuyClick} 
                                                        imageSize={{x: props.windowSize.x <= 960 ? 280 : 430, y: props.windowSize.x <= 960 ? 220 : 500}} 
                                                        eurprice={props.eurprice} 
                                                        satprice={props.satprice}
                                                        onImageClick={props.onImageClick} 
                                                        product={product} />
                                                </div>
                                    })}
                                </Stack>}
        </Stack>
    );    
}

export default Misc;